import { Suspense, lazy, type ComponentProps } from "react";

/**
 * Code-split entry for the camera scanner: `@zxing/library` is ~500 kB and is
 * needed only when someone actually taps "Skeniraj QR", so it lives in its own
 * chunk and loads on first open.
 */
const QrScannerModalImpl = lazy(() =>
  import("./QrScannerModal").then((m) => ({ default: m.QrScannerModal })),
);

export function QrScanner(props: ComponentProps<typeof QrScannerModalImpl>) {
  return (
    <Suspense fallback={null}>
      <QrScannerModalImpl {...props} />
    </Suspense>
  );
}
